@if (vm$ | async; as vm) {
    @if (vm.info) {
        <div class="pc-text">
            <ng-container *msShowInEpcot="false">
                @if (!!vm.info.message) {
                    <a class="linkbox betslip-error add-header">
                        <h4 class="theme-error-i">{{ vm.info.message }} {{ vm.info.failedInfo ?? '' }}</h4>
                    </a>
                }
                @if (!!vm.info.remainingText) {
                    <a class="linkbox betslip-error">
                        <h4 class="theme-error-i" [innerHTML]="vm.info.remainingText"></h4>
                    </a>
                }
            </ng-container>
            <ng-container *msShowInEpcot="true">
                @if (!!vm.info.message) {
                    <ms-epcot-notification
                        [notificationHeaderTitle]="vm.info.message + ' ' + (vm.info.failedInfo ?? '')"
                        [notificationType]="'error'" />
                }
                @if (!!vm.info.remainingText) {
                    <ms-epcot-notification [notificationHeaderTitle]="vm.info.remainingText" [notificationType]="'info'" />
                }
            </ng-container>
        </div>
    }
    @for (slip of vm.slips; track slip) {
        <bs-digital-result-failed-slip [slip]="slip" [oddsDisplayFormat]="oddsDisplayFormat" />
    }
}
